import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { changePassword } from "@/lib/api";

export const ForcePasswordChange = ({ email, onDone, onLogout }) => {
  const [curPw, setCurPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (newPw.length < 8) return toast.error("New password must be at least 8 characters.");
    if (newPw !== confirm) return toast.error("Passwords don't match.");
    setSaving(true);
    try {
      await changePassword(curPw, newPw);
      toast.success("Password set. Welcome aboard!");
      onDone();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Couldn't set your password.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-sand px-6">
      <div className="w-full max-w-sm bg-white border border-border rounded-2xl p-8 shadow-[0_8px_32px_rgba(17,42,34,0.05)]" data-testid="force-password-change">
        <div className="grid h-11 w-11 place-items-center rounded-xl bg-clay text-white">
          <KeyRound className="h-5 w-5" strokeWidth={2} />
        </div>
        <h1 className="mt-5 font-heading text-2xl text-ink">Set your password</h1>
        <p className="mt-1 text-sm text-ink-muted">
          Welcome, {email}. Please choose a new password to continue.
        </p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label className="text-ink font-medium">Temporary password</Label>
            <Input type="password" data-testid="fpc-current" value={curPw} onChange={(e) => setCurPw(e.target.value)} required className="mt-2 bg-white border-border focus-visible:ring-clay rounded-xl py-6" />
          </div>
          <div>
            <Label className="text-ink font-medium">New password</Label>
            <Input type="password" data-testid="fpc-new" value={newPw} onChange={(e) => setNewPw(e.target.value)} required className="mt-2 bg-white border-border focus-visible:ring-clay rounded-xl py-6" />
          </div>
          <div>
            <Label className="text-ink font-medium">Confirm new password</Label>
            <Input type="password" data-testid="fpc-confirm" value={confirm} onChange={(e) => setConfirm(e.target.value)} required className="mt-2 bg-white border-border focus-visible:ring-clay rounded-xl py-6" />
          </div>
          <Button type="submit" data-testid="fpc-submit" disabled={saving} className="w-full bg-clay hover:bg-clay-hover text-white rounded-lg py-6 font-medium">
            {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : "Set password & continue"}
          </Button>
        </form>
        <button type="button" onClick={onLogout} className="mt-4 inline-flex items-center gap-1.5 text-sm text-ink-muted hover:text-ink">
          <LogOut className="h-4 w-4" /> Sign out
        </button>
      </div>
    </div>
  );
};
